import { axiosNewAjax, axiosAjax } from '@/utils/ajax'

export default class TrainClassTestApi {
    // 通过用户id获取,培训班下拉列表数据 //学员
    static getClassListByUserId(id) {
        return axiosAjax('get', `/studyapp-service/trainClassTest/getClassListByUserId?id=${id}`)
    }
    // 通过用户id获取,培训班下拉列表数据 //教员
    static getClassListByTacherId(id) {
        return axiosAjax('get', `/studyapp-service/trainClassTest/getClassListByTacherId?id=${id}`)
    }
    //  模拟成绩列表开始
    static getClassMemberByDepId(data) {
        return axiosAjax('post', '/comuser-service/Account/getClassMemberByDepId', data)
    }

    static getScoreList(data) {
        return axiosAjax('post', '/studyapp-service/trainClassTest/getScoreList', data)
    }

    static getTotalScoreByNewCourse(data) {
        return axiosAjax('post', '/studyapp-service/score/getTotalScoreByNewCourse', data)
    }


    static getTotalScore(data) {
        return axiosAjax('post', '/studyapp-service/trainClassTest/getTotalScore', data)
    }

    static getAvgScore(data) {
        return axiosAjax('post', '/studyapp-service/trainClassTest/getAvgScore', data)
    }

    static getIcaoScore(data) {
        return axiosAjax('post', '/studyapp-service/trainClassTest/getIcaoScore', data)
    }
    //  模拟成绩列表结束

    //获取执照
    static findDictsByUuid(data) {
        return axiosAjax('post', '/auth-config-service/sysDict/findDictsByUuid', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/trainClassTestApi.js